var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAcceptMark = function SvgAcceptMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 33,
    viewBox: "0 0 60 46",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5009 35.9989L5.5009 21.9989L0.834229 26.6655L19.5009 45.3322L59.5009 5.33219L54.8342 0.665527L19.5009 35.9989Z"
  })));
};
export { SvgAcceptMark as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iMzMiIHZpZXdCb3g9IjAgMCA2MCA0NiIgZmlsbD0iY3VycmVudENvbG9yIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMTkuNTAwOSAzNS45OTg5TDUuNTAwOSAyMS45OTg5TDAuODM0MjI5IDI2LjY2NTVMMTkuNTAwOSA0NS4zMzIyTDU5LjUwMDkgNS4zMzIxOUw1NC44MzQyIDAuNjY1NTI3TDE5LjUwMDkgMzUuOTk4OVoiIC8+Cjwvc3ZnPgo=";